module.exports = __webpack_public_path__ + "0386991ee0077fc1587d5d8eff5dc8be.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fair/promotion.png
// module id = ./assets/images/fair/promotion.png
// module chunks = 0